import { render, staticRenderFns } from "./additional_family_member_principle.vue?vue&type=template&id=be74237c&"
import script from "./additional_family_member_principle.vue?vue&type=script&lang=js&"
export * from "./additional_family_member_principle.vue?vue&type=script&lang=js&"
import style0 from "./additional_family_member_principle.vue?vue&type=style&index=0&id=be74237c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports